import TextTransformer from "./TextTransformer";

export enum InterlinearNumberStyle {
    None,
    AddStandardSequential,
    AddAlternateSequential,
    ReplaceSequential,
    ReplaceNonSequential
}

export default interface VersionStyle {
    readonly classes?: string[];
    readonly interlinearNumberStyle?: InterlinearNumberStyle;
    readonly allowLexiconLookup?: boolean;
    readonly wordTooltipGenerator?: TextTransformer;
    readonly wordPartTransformer?: TextTransformer;
    readonly wordPartSeparator?: string;
    readonly wordPartJoiner?: string;
}
